import { render } from "./BoardFilter.vue?vue&type=template&id=499d0c8c"
import script from "./BoardFilter.vue?vue&type=script&lang=js"
export * from "./BoardFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__